import { Dispatch, SetStateAction } from "react";
import { IBankHoursStatement } from "../models";
import { mes } from "./constants/getMes";

interface IListDetails {
  listDetails: IBankHoursStatement[];
  page: number;
  selectSize: number;
}

export default function TableListDetails({ listDetails = undefined, page, selectSize }: IListDetails) {
  function listRenderObserverThePage(indexOfLine: number) {
    const initialListRender = indexOfLine < (page + 1) * selectSize;
    const endListRender = indexOfLine >= page * selectSize;
    return initialListRender && endListRender;
  }

  function totalHours(item: IBankHoursStatement) {
    if (item?.totalHours) return item?.totalHours;
    if (item?.bankHours?.includes("-")) return "Débito";
    return "--";
  }

  function status(item: IBankHoursStatement) {
    switch (item?.status) {
      case "PAID":
        return "Pagamento";
      case "PENDING":
        return "Pendente";
      case "REST":
        return "Descanso";
      default:
        return "--";
    }
  }

  function getTimeCourse(date: any): string {
    if (!date) return "--";
    const [year, month] = date?.split("-");
    return `${mes[month - 1]}/${year}`;
  }

  return (
    <>
      <div className="collaboratorTableContainer table-container-full box-shadow">
        <table className="collaboratorTable table-container-header-body">
          {!!listDetails?.length ? (
            <thead>
              <tr>
                <th className="header-left">Total de horas</th>
                <th className="header-left">Horas aprovadas</th>
                <th className="header-left">Mês da modificação</th>
                <th className="header-left">Status</th>
                <th className="header-left">Saldo</th>
              </tr>
            </thead>
          ) : (
            <div className="nothing-list flex justify-center width-100">
              <h1>Não há registros para a busca realizada.</h1>
            </div>
          )}
          <tbody>
            {listDetails?.map((item: IBankHoursStatement, index) => {
              return (
                listRenderObserverThePage(index) && (
                  <tr className="collaboratorTableRow">
                    <td>{totalHours(item)}</td>
                    <td>{item?.approvedHours || "--"}</td>
                    <td>{getTimeCourse(item?.timeCourse)}</td>
                    <td>{status(item)}</td>
                    <td>
                      <span className={item?.bankHours?.includes("-") ? "bank-red" : "bank-green"}>{item?.bankHours}</span>
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
